import axios from 'axios';
import {bind, compose, prop,} from 'ramda';

const printError = bind(console.error, console);
const reject = bind(Promise.reject, Promise);
const handleErrorAndReject = compose(
    reject,
    printError
);
const data = prop('data');

/** @typedef {import('axios').AxiosRequestConfig} AxiosRequestConfig */

/**
 * Make request
 *
 * On error print log and reject with `undefined`
 *
 * @param {AxiosRequestConfig} config
 */
const request = (config) =>
    axios.request(config)
        .then(data)
        .catch(handleErrorAndReject);

/**
 * Make POST request
 *
 * @param {string} url
 * @param {AxiosRequestConfig?} config
 * @param {FormData|URLSearchParams?} data
 */
export const post = (url, config, data) =>
    request({...config, url, data, method: 'post'});

/**
 * Make GET request
 *
 * @param {string} url
 * @param {AxiosRequestConfig?} config
 * @param {URLSearchParams?} params
 */
export const get = (url, config, params) =>
    request({...config, url, params, method: 'get'});
